"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'CustomSelectListModal',
  // 选择列表模态框组件，适用于通过点击“添加”按钮，弹出模态框选择列表后通过table展示数据，并支持修改某个字段值的业务场景。如“添加货品”
  props: {
    // 展示文案，类似form的label，也可以是slot
    label: {
      type: String,
      default: null
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    // 获取列表的请求方法
    method: {
      type: Function,
      required: true
    },
    // 获取列表的请求参数
    params: {
      type: Object,
      default: () => {}
    },
    // 按钮右边显示的提示语
    desc: {
      type: String,
      default: undefined
    },
    // 按钮和模态框的标题
    modalTitle: {
      type: String,
      default: '添加' // 如添加货品
    },
    // 选择数据模态框中的表格columns
    modalColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 已选择的表格columns
    listColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    /**
     * @description: 可编辑表格columns
     * @return {array}
     * [{
     *  dataIndex: 'rangeDate', // 与 columns 的dataIndex一致
     *  title: '生效时间', // 与 columns 的title一致
     * ...column.props // column支持的各种属性
     *  batchEdit: true, // 是否支持批量修改
     *  batchEditTitle: '批量修改生效时间', // 批量修改模态框的标题，不传则使用“批量修改+外层title的值”，也是批量编辑按钮的文案
     *  value: [], // 默认值，与valueType配合适用，当valueType属于数组时，value需要设置为“[]”，默认为空字符串。Warning: 如果类型不一致会报错提示类型不正确。
     *  valueType: 'ARangePicker', // 编辑状态时使用的组件类型，如 AInput，内置了input和inputNumber，不写默认为input
     *  fieldProps: {}, // 编辑组件的props属性
     *  required: true, // 是否必填
     *  message: '请选择生效时间', // 校验不通过时的提示语，默认为“请输入”
     * }]
     */
    editableColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 默认选择的selectedRowKeys
    defaultSelectedRowKeys: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 默认选择的selectedRows
    defaultSelectedRows: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tableScroll: {
      type: Object,
      default: () => {
        return {
          y: '300px'
        };
      }
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      selectedRowKeys: [],
      selectedRows: [],
      selectedIds: [],
      form: {
        dataSource: []
      },
      curPagination: {
        current: 1,
        pageSize: 20
      },
      valid: false,
      // 表单是否通过校验

      // 批量编辑相关 S
      batchEditVisible: false,
      curEditData: {},
      editForm: {}
      // 批量编辑相关 E
    };
  },
  computed: {
    curSelectedRowKeys() {
      return this.form.dataSource.map(item => item[this.rowKey]);
    },
    // 显示的批量操作按钮
    batchEditButtons() {
      return this.editableColumns.filter(column => column.batchEdit === true);
    }
  },
  watch: {
    // 默认值回填 优先回填defaultSelectedRows
    defaultSelectedRows: {
      handler(val, oldVal) {
        // 首次有值时才赋默认值
        if (!_.isEmpty(val) && _.isEmpty(oldVal)) {
          this.form.dataSource = _.cloneDeep(val);
        }
      },
      immediate: true,
      deep: true
    },
    defaultSelectedRowKeys: {
      handler(val, oldVal) {
        // 首次有值时才赋默认值
        if (!(!_.isEmpty(val) && _.isEmpty(oldVal))) return;
        if (this.defaultSelectedRows.length === 0) {
          this.form.dataSource = val.map(item => {
            const obj = {};
            obj[this.rowKey] = item;
            return obj;
          });
        }
      },
      immediate: true
    },
    'form.dataSource': {
      handler(newVal, oldVal) {
        this.$nextTick(async () => {
          const valid = await this.validate();
          // 初始化时不激活表单校验
          if (oldVal !== undefined) {
            const res = {
              selectedRowKeys: this.curSelectedRowKeys,
              selectedRows: newVal,
              valid
            };
            // 如果需要获取rowKey对应字段以外的更多数据，可通过change事件获取
            this.$emit('change', res);
            this.$emit('input', this.curSelectedRowKeys.toString());
          }
        });
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    // 使用 Lodash 实现防抖
    this.debounceFieldChange = _.debounce(this.handleEditFieldChange, 200);
    this.initEditForm();
  },
  unmounted() {
    // 移除组件时，取消定时器
    this.debounceFieldChange.cancel();
  },
  methods: {
    handleOpen() {
      this.selectedRowKeys = this.curSelectedRowKeys;
      this.selectedRows = this.form.dataSource;
      this.visible = true;
    },
    // 选择表格
    handleRowSelectionChange({
      selectedRowKeys,
      selectedRows
    }) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 点击选择列表模态框的“确认”按钮
    confirmSelectedResult() {
      const {
        selectedRowKeys,
        selectedRows,
        editableColumns = []
      } = this;
      if (selectedRowKeys.length === 0) {
        this.$message.warning('请先选择需要的数据');
        return;
      }
      this.form.dataSource = selectedRows.map(item => {
        // 由于源数据不一定拥有column.dataIndex相应的字段，故需进行初始化，否则无法触发表单更新校验
        editableColumns.forEach(column => item[column.dataIndex] = item[column.dataIndex] || column.value || '');
        return item;
      });
      this.visible = false;
    },
    afterClose() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    // 批量删除
    handleBatchDel() {
      _.cloneDeep(this.selectedIds).forEach(item => this.handleDel(item));
    },
    // 单个删除
    handleDel(targetValue) {
      const index = this.form.dataSource.findIndex(item => item[this.rowKey] === targetValue);
      this.form.dataSource.splice(index, 1);
      const idIndex = this.selectedIds.findIndex(item => item === targetValue);
      this.selectedIds.splice(idIndex, 1);
    },
    // 修改可编辑字段
    handleEditFieldChange(record, dataIndex) {
      const {
        rowKey
      } = this;
      const index = this.form.dataSource.findIndex(item => item[rowKey] === record[rowKey]);
      this.form.dataSource[index][dataIndex] = record[dataIndex];
      this.form.dataSource.splice(0, 0);
    },
    // 批量编辑相关 S
    initEditForm() {
      if (this.editableColumns.length === 0) return;
      const obj = {};
      this.editableColumns.forEach(column => obj[column.dataIndex] = column.value || undefined);
      this.editForm = obj;
    },
    handleOpenEditModal(data) {
      this.curEditData = data;
      this.batchEditVisible = true;
    },
    // 批量编辑
    handleBatchEdit() {
      const {
        rowKey,
        curEditData: {
          dataIndex
        },
        selectedIds,
        editForm
      } = this;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          try {
            const dataSource = _.cloneDeep(this.form.dataSource);
            dataSource.forEach(record => {
              if (selectedIds.includes(record[rowKey])) record[dataIndex] = editForm[dataIndex];
            });
            this.form.dataSource = dataSource;
            this.initEditForm();
            this.batchEditVisible = false;
          } catch (e) {}
        }
      });
    },
    // 批量编辑相关 E
    // 触发表单校验-父组件通过 this.$refs.customSelectListModal.validate() 方式调用
    async validate() {
      try {
        await (this.$refs.form && this.$refs.form.validate());
        this.valid = true;
        this.$emit('update:valid', true);
        return true;
      } catch (error) {
        this.valid = false;
        this.$emit('update:valid', false);
        return false;
      }
    }
  }
};